export enum PaymentRefundStatusEnum {
  NEW = 'new',
  APPROVED = 'approved',
  REJECTED = 'rejected'
}

export const localizedPaymentRefundStatuses: Record<
  PaymentRefundStatusEnum,
  string
> = {
  [PaymentRefundStatusEnum.NEW]: 'Новая',
  [PaymentRefundStatusEnum.APPROVED]: 'Одобрена',
  [PaymentRefundStatusEnum.REJECTED]: 'Отклонена'
};

export const PAYMENT_REFUND_STATUSES: PaymentRefundStatusEnum[] = [
  PaymentRefundStatusEnum.NEW,
  PaymentRefundStatusEnum.APPROVED,
  PaymentRefundStatusEnum.REJECTED
];
